import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { contentAPI } from "../api/endpoints";
import ContentRow from "../components/ContentRow";
import PageSkeleton from "../components/PageSkeleton";

export default function Movies() {
  const navigate = useNavigate();
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    contentAPI
      .getMovies()
      .then((res) => {
        // /api/movie/launcher returns ArrayList<MovieContentResponse>
        setSections(res.data || []);
      })
      .catch(() => { })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="pt-20">
        <div className="px-5 md:px-10 max-w-[1400px] mx-auto mb-8">
          <div className="w-32 h-8 bg-dark-700 rounded-md animate-pulse"></div>
          <div className="w-48 h-4 bg-dark-800 rounded-md mt-2 animate-pulse"></div>
        </div>
        <PageSkeleton withHero={false} />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-dark-900 pt-20 pb-16">
      {/* Page Header */}
      <div className="px-5 md:px-10 max-w-[1400px] mx-auto mb-8">
        <h1 className="text-3xl font-bold text-white">Movies</h1>
        <p className="text-gray-500 text-sm mt-1">Browse movies by genre</p>
      </div>

      {/* Sections */}
      {sections.length > 0 ? (
        sections.map((section) => (
          <ContentRow
            key={section.id}
            title={section.title}
            items={section.data || []}
            type="movie"
            onSeeAll={() => navigate(`/category?type=${encodeURIComponent(section.type)}&title=${encodeURIComponent(section.title)}&content_type=movie`)}
          />
        ))
      ) : (
        <div className="text-center py-20 text-gray-500">
          <p className="text-lg">No movies available right now</p>
        </div>
      )}
    </div>
  );
}
